"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Resource = void 0;
const node_dotify_1 = __importDefault(require("node-dotify"));
class Resource {
    constructor(connection) {
        this.connection = connection;
        this.opts = {};
    }
    withOptions(opts) {
        this.opts = opts;
        return this;
    }
    resetOptions() {
        this.opts = {};
        return this;
    }
    async sendGet(url, query) {
        let response;
        if (query !== undefined) {
            response = await this.connection.get(url, { ...this.opts, ...{ searchParams: node_dotify_1.default(query) } });
        }
        else {
            response = await this.connection.get(url, this.opts);
        }
        this.resetOptions();
        return response;
    }
    async sendPost(url, body, query) {
        let response;
        if (query !== undefined) {
            response = await this.connection.post(url, { ...this.opts, ...{ body }, ...{ searchParams: node_dotify_1.default(query) } });
        }
        else {
            response = await this.connection.post(url, { ...this.opts, ...{ body } });
        }
        this.resetOptions();
        return response;
    }
}
exports.Resource = Resource;
//# sourceMappingURL=resource.js.map